import { CompetitorPricesDTO } from '../../dto';
import { CompetitorItem } from './CompetitorItem';
import { Store } from './Store';

interface CompetitorPricesProps {
  stores: Store[];
  totalNumberOfItems: number;
  foundNumberOfItems: number;
  competitorItems: CompetitorItem[];
}

export class CompetitorPrices {
  stores: Store[];
  totalNumberOfItems: number;
  foundNumberOfItems: number;
  competitorItems: CompetitorItem[];

  constructor({
    stores,
    totalNumberOfItems,
    foundNumberOfItems,
    competitorItems,
  }: CompetitorPricesProps) {
    this.stores = stores;
    this.totalNumberOfItems = totalNumberOfItems;
    this.foundNumberOfItems = foundNumberOfItems;
    this.competitorItems = competitorItems;
  }

  static fromDto = (dto: CompetitorPricesDTO): CompetitorPrices =>
    new CompetitorPrices({
      stores: dto.stores ? dto.stores.map(Store.fromDto) : [],
      totalNumberOfItems: dto.totalNumberOfItems,
      foundNumberOfItems: dto.foundNumberOfItems,
      competitorItems: dto.competitorItems ? dto.competitorItems.map(CompetitorItem.fromDto) : [],
    });
}
